"use client";

import { Component, type ErrorInfo, type ReactNode } from "react";

export class ErrorBoundary extends Component<
  { children: ReactNode },
  { failed: boolean }
> {
  state = { failed: false };

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error("Dashboard render error", error.message, info.componentStack);
  }

  render() {
    if (this.state.failed) {
      return (
        <main className="standalone-shell">
          <section className="standalone-card" role="alert">
            <p className="eyebrow">SAFE FALLBACK</p>
            <h1>畫面暫時無法顯示</h1>
            <p>頁面遇到非預期錯誤，但這不會影響 MT5 Publisher 或交易。請重新整理後再試一次。</p>
            <button className="button primary" type="button" onClick={() => window.location.reload()}>
              重新整理
            </button>
          </section>
        </main>
      );
    }
    return this.props.children;
  }
}
